export default "__VITE_ASSET__FOCE2xOe__"